import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const MusicFileUpload2Icon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11 22H18.5C19.0304 22 19.5391 21.7893 19.9142 21.4142C20.2893 21.0391 20.5 20.5304 20.5 20V7L15.5 2H6.5C5.96957 2 5.46086 2.21071 5.08579 2.58579C4.71071 2.96086 4.5 3.46957 4.5 4V12.4"
        stroke={fillColor || '#E0E4E4'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M8.5 18V10.3L16.5 9V16" stroke={fillColor || '#E0E4E4'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M14.5 18C15.6046 18 16.5 17.1046 16.5 16C16.5 14.8954 15.6046 14 14.5 14C13.3954 14 12.5 14.8954 12.5 16C12.5 17.1046 13.3954 18 14.5 18Z"
        stroke={fillColor || '#E0E4E4'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 20C7.60457 20 8.5 19.1046 8.5 18C8.5 16.8954 7.60457 16 6.5 16C5.39543 16 4.5 16.8954 4.5 18C4.5 19.1046 5.39543 20 6.5 20Z"
        stroke={fillColor || '#E0E4E4'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { MusicFileUpload2Icon };
